<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <div class="col-md-12">
      <div class="page-breadcrumb">
        <ul class="page-breadcrumb__trail">
          <li><a>Manage</a></li>
          <li><a>Requests</a></li>
          <li><a>Requests</a></li>
        </ul>
      </div>
      <div class="block">
        <div class="page-header">
          <span class="page-header__title">Requests</span>
          <img src="assets/images/New_Icons/refresh-icon.svg" alt="Refresh icon" title="Refresh" class="page-header__icon" width="17" height="17" (click)="!enableDisablePageLoader ? ngOnInit() : null"/>
        </div>
        <div class="list_block">
          <div class="toolbar">
            <div class="toolbar__search">
              <img src="../../../../../../assets/images/New_Icons/search-icon.svg" alt="Search icon">
              <input type="text" (ngModelChange)="onSearchChanged()" [(ngModel)]="search" name="search" autocomplete="off" placeholder="Search by farm, issue type, serial no, status.."/>
            </div>
            <div class="toolbar__spacer"></div>
            <div class="toolbar__add-button" (click)="openForm()">
              <button type="button">
                <span class="toolbar__add-icon">
                  <img src="../../../../../../assets/images/New_Icons/plus-icon.svg" alt="Add Icon"/>
                </span>
                <span class="toolbar__add-text">Add New</span>
              </button>
            </div>
          </div>
        </div>
        <div *ngIf="enableDisablePageLoader">
          <div class="adjust">
            <div class="loader2"></div>
          </div>
        </div>
        <div class="cards_container" *ngIf="!enableDisablePageLoader">
          <div class="card_wrapper" *ngFor="let servicerequest of serviceRequestsList; let i = index">
            <div class="master-card">
              <div class="master-card-header">
                <div class="master-card-title">
                  <img src="../../../../../../assets/images/New_Icons/card-heading.svg" alt="Left arrow icon">
                  <span>{{ servicerequest && servicerequest.BusinessDetails && servicerequest.BusinessDetails[0] && servicerequest.BusinessDetails[0].businessName }}</span>
                </div>
              </div>
              <div class="master-card-body">
                <div class="master-card-body-info">
                  <span class="card-content-text">SR Request No:</span>
                  <span class="text">SR-{{ servicerequest?.id }}</span>
                </div>
                <div class="master-card-body-info">
                  <span class="card-content-text">Issue Type:</span>
                  <span class="text">{{ servicerequest?.srTopics?.name || 'NA' }}</span>
                </div>
                <div class="master-card-body-info">
                  <span class="card-content-text">Serial Number:</span>
                  <span class="text">{{ servicerequest?.device?.serial_number || 'NA' }}</span>
                </div>
                <div class="master-card-body-info">
                  <span class="card-content-text">Assigned To:</span>
                  <span class="text">{{ (servicerequest?.personDetails && servicerequest?.personDetails[0]) ? (servicerequest.personDetails[0].firstName + ' ' + (servicerequest.personDetails[0].lastName || '')) : 'NA' }}</span>
                </div>
                <div class="master-card-body-info">
                  <span class="card-content-text">Status:</span>
                  <span class="badge-tag" [ngClass]="{
                    'status-pending': servicerequest?.ssCode?.code === 'Pending',
                    'status-assigned': servicerequest?.ssCode?.code === 'Assigned',
                    'status-inprogress': servicerequest?.ssCode?.code === 'In Progress',
                    'status-resolved': servicerequest?.ssCode?.code === 'Resolved' || servicerequest?.ssCode?.code === 'Completed',
                    'status-closed': servicerequest?.ssCode?.code === 'Closed'
                  }">{{ servicerequest?.ssCode?.code || 'NA' }}</span>
                </div>
                <div class="master-card-body-info">
                  <span class="card-content-text">Start Date:</span>
                  <span class="text">{{ servicerequest?.sr_start_date | date: "dd MMM yyyy" }}</span>
                </div>
              </div>
              <div class="master-card-footer">
                <div class="master-card-footer-info">
                  <span class="label">Updated At:</span>
                  <span class="text">{{ servicerequest?.updatedAt | date: "dd MMM yyyy" }}</span>
                </div>
                <div class="action-icons">
                  <a>
                    <img src="../../../../../../assets/images/New_Icons/edit.svg" alt="Edit icon" title="Edit Service Request" (click)="getServiceRequestById(servicerequest.id)">
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="listLoader" class="loader-div">
          <div class="adjust">
            <div class="loader2 list-loader"></div>
          </div>
        </div>
        <div *ngIf="noList && !enableDisablePageLoader" class="noDataFoundMessage">Service Requests Not Found</div>
      </div>

      <!--add/update form-->
      <div class="dynamic-form-wrapper" [ngClass]="{ 'floating-panel': formFieldCount <= 7, 'slide-in-overlay': formFieldCount > 7}" *ngIf="showForm">
        <div class="popup-wrapper">
          <button type="button" class="popup-close-beside" (click)="clear()" title="Close">&times;</button>
          <!-- Actual Popup -->
          <div [ngClass]="{ 'form-container-panel': formFieldCount > 7, 'popup-inner': formFieldCount <= 7}">
            <form [formGroup]="registerForm" novalidate>
              <div class="form-header">
                <div class="form-title">Service Request</div>
                <button type="button" class="add-update-submit-button" (click)="submitButton ? addServiceRequest() : updateServiceRequest()" [disabled]="serviceRequestDoubleClick">
                  <span class="icon"><img src="../../../../../../assets/images/New_Icons/tick-icon.svg" alt="Tick icon"></span>
                  <span class="text">{{ submitButton ? 'Submit' : 'Update' }}</span>
                </button>
              </div>
              <div class="form-container">
                <!-- Issue Type -->
                <mat-form-field appearance="outline" class="w-100 density-compact">
                  <mat-label>Issue Type</mat-label>
                  <mat-select formControlName="issuetype" [(ngModel)]="serviceRequest.topic_id">
                    <mat-option value="" disabled>Select Issue Type</mat-option>
                    <mat-option *ngFor="let srtopic of srTopics" [value]="srtopic.id">
                      {{ srtopic.name }} - {{ srtopic.description }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="(srFormValidation.issuetype.touched || submitted) && srFormValidation.issuetype.hasError('required')">
                    <i>Issue type is required.</i>
                  </mat-error>
                </mat-form-field>

                <!-- Assigned To -->
                <mat-form-field appearance="outline" class="w-100 density-compact" *ngIf="loginPersonType !== 'Farmer' && loginPersonType !== 'Business Admin' && loginPersonType !== 'Farm Manager'">
                  <mat-label>Assigned To</mat-label>
                  <mat-select formControlName="assignedto" [(ngModel)]="serviceRequest.assignedTo">
                    <mat-option [value]="null">Select Assigned To</mat-option>
                    <mat-option *ngFor="let person of persons" [value]="person.id">
                      {{ person.firstName + ' ' + (person.lastName || '') }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <!-- Farm Name -->
                <mat-form-field appearance="outline" class="w-100 density-compact" *ngIf="submitButton">
                  <mat-label>Farm Name</mat-label>
                  <mat-select formControlName="farmname" [(ngModel)]="serviceRequest.business_id" (selectionChange)="getAllMapDeviceWithBusiness(serviceRequest.business_id)">
                    <mat-option value="" disabled>Select Farm Name</mat-option>
                    <mat-option *ngFor="let businessentity of businessEntities" [value]="businessentity.id">
                      {{ businessentity.businessName }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="(srFormValidation.farmname.touched || submitted) && srFormValidation.farmname.hasError('required')">
                    <i>Farm name is required.</i>
                  </mat-error>
                </mat-form-field>

                <!-- Device Serial Number -->
                <mat-form-field appearance="outline" class="w-100 density-compact" *ngIf="submitButton">
                  <mat-label>Device Serial Number</mat-label>
                  <mat-select formControlName="serialno" [(ngModel)]="serviceRequest.device_id">
                    <mat-option value="" disabled>Select Device Serial Number</mat-option>
                    <mat-option *ngFor="let customerdevice of customerDevices" [value]="customerdevice.device_id">
                      {{ customerdevice.device?.serial_number }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="(srFormValidation.serialno.touched || submitted) && srFormValidation.serialno.hasError('required')">
                    <i>Device serial number is required.</i>
                  </mat-error>
                </mat-form-field>

                <!-- Status (on Edit) -->
                <mat-form-field appearance="outline" class="w-100 density-compact" *ngIf="updateButton">
                  <mat-label>Status</mat-label>
                  <mat-select formControlName="status" [(ngModel)]="serviceRequest.ss_code_id">
                    <mat-option value="" disabled>Select Status</mat-option>
                    <mat-option *ngFor="let srcode of srCodes" [value]="srcode.id">
                      {{ srcode.code }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <!-- Description -->
                <mat-form-field appearance="outline" class="w-100 density-compact">
                  <mat-label>Description</mat-label>
                  <textarea matInput formControlName="desc" [(ngModel)]="serviceRequest.description" rows="3" placeholder="Enter description"></textarea>
                  <mat-hint><i>Up to 360 characters</i></mat-hint>
                  <mat-error *ngIf="(srFormValidation.desc.dirty || srFormValidation.desc.touched || submitted) && srFormValidation.desc.hasError('maxlength')">
                    <i>Maximum 360 characters allowed.</i>
                  </mat-error>
                </mat-form-field>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
